import moment from 'moment';
import currencyFormatter from 'currency-formatter';

/**
 * Formats the iso8601 string to a shorter version to fit in small places.
 * @param cell AG Grid cell object with UTC string value.
 * @return {string} A short string date
 */
function formatDatetimeShortLocal(cell) {
  const cellDate = cell.value;
  const inputFormat = 'YYYY-MM-DD[T]HH:mm:ss[Z]';
  return (
    cellDate
      ? moment.utc(cellDate, inputFormat).local().format('[Local Time: ]MM/DD/YY hh:mm a')
      : '--'
  );
}

/**
 * Formats the iso8601 string to a shorter version to fit in small places.
 * @param cell AG Grid cell object with UTC string value.
 * @return {string} A short string date
 */
function formatDatetimeShort(cell) {
  const cellDate = cell.value;
  const inputFormat = 'YYYY-MM-DD[T]HH:mm:ss[Z]';
  return cellDate ? moment.utc(cellDate, inputFormat).format('MM/DD/YY HH:mm') : '--';
}

/**
 * Formats a number to a currency string.
 * @param cell The AG Grid Cell
 * @param currency An ISO-4217 currency code
 * @return {string} a currency formatted string.
 */
function formatCurrency(cell, currency = 'USD') {
  return currencyFormatter.format(cell.value, { code: currency });
}

/**
 * Format a cell as either a value or '--' if the value is nil.
 * @param cell The AG Grid Cell
 * @param field The field on the cell's value object to check
 * @returns {string} The field value or '--'
 */
function dashIfEmpty(cell, field) {
  const value = cell.value[field];
  return value || '--';
}

export default {
  formatDatetimeShortLocal,
  formatDatetimeShort,
  formatCurrency,
  dashIfEmpty,
};
